import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/vercel/path0/components/layout/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
